import { useLocation } from 'react-router';
import { useGetUserCountry } from 'react-easyrocket';
import { useEffect } from 'react';
import { executeAdditionalGTMScript, getUserIdFromLS } from 'src/utils';

/** Хук для действий, которые нужно делать на каждый переход между страницами.
 * Т.е. просто добавляем эффекты с pathname в зависимостях для каждого нового действия
 */
export const useDoSomethingOnEveryPage = () => {
  const { pathname } = useLocation();
  const { refetch: refetchUserCountry } = useGetUserCountry();

  useEffect(() => {
    executeAdditionalGTMScript(getUserIdFromLS());
    refetchUserCountry();
  }, [pathname]);

  useEffect(() => {
    if (pathname.includes('games')) return;
    window.scrollTo({ top: 0 });
  }, [pathname]);
};
